
 import React, { useEffect, useState, useRef } from "react";
import {
  FaSignOutAlt,
  FaBars,
  FaUserCircle,
  FaEdit,
  FaTrash,
  FaPlus,
  FaTimes,
  FaEye,
  FaCheck,
  FaCertificate,
  FaDownload,
  FaSearch,
} from "react-icons/fa";
import {
  MdApps,
  MdBadge,
  MdBuild,
  MdBusiness,
  MdBusinessCenter,
  MdCategory,
  MdDashboard,
  MdEvent,
  MdGrade,
  MdGroup,
  MdHome,
  MdImage,
  MdInsertChart,
  MdLink,
  MdList,
  MdMenu,
  MdPerson,
  MdPhotoLibrary,
  MdPostAdd,
  MdSettings,
  MdSlideshow,
  MdStar,
  MdStore,
  MdTv,
  MdVerified,
  MdWork,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import {
  FacebookEmbed,
  InstagramEmbed,
  YouTubeEmbed,
} from "react-social-media-embed"
import { State, City } from "country-state-city";
import './Admin.css';

const API = "https://api.propertygalleria.in";
 
 
 
 export const Sliders = () => {
 
 
 
 const [sliders, setSliders] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const [form, setForm] = useState({
    title: "",
    description: "",
    image: null,
  });

  const [editingID, setEditingID] = useState(null);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(sliders.length / itemsPerPage);
  const currentItems = sliders.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Fetch Sliders
  const fetchSliders = async () => {
    const { data } = await axios.get(`${API}/api/sliders`);
    setSliders(data);
  };

  useEffect(() => {
    fetchSliders();
  }, []);

  const handleImage = (e) => {
    setForm({ ...form, image: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append("title", form.title);
    fd.append("description", form.description);
    if (form.image instanceof File) fd.append("image", form.image);

    if (editingID) {
      await axios.put(`${API}/api/sliders/${editingID}`, fd);
    } else {
      await axios.post(`${API}/api/sliders`, fd);
    }

    setShowModal(false);
    setEditingID(null);
    setForm({ title: "", description: "", image: null });
    fetchSliders();
  };

  const handleEdit = (slide) => {
    setEditingID(slide.id);
    setForm({
      title: slide.title,
      description: slide.description,
      image: slide.image,
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this slide?")) return;
    await axios.delete(`${API}/api/sliders/${id}`);
    fetchSliders();
  };


     return (
      <div style={{ background: "#fff", padding: 25, borderRadius: 12 }}>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h2 style={{ color: "var(--primary)" }}>Sliders</h2>
  
          <button
            onClick={() => {
              setForm({ title: "", description: "", image: null });
              setEditingID(null);
              setShowModal(true);
            }}
            style={{
            /* PG PRIMARY BUTTON */
  background: "linear-gradient(135deg, var(--pg-primary), var(--pg-accent))",
  
              color: "#fff",
              border: "none",
              padding: "8px 13px",
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              height: "40px",
              cursor: "pointer",
            }}
          >
            <FaPlus style={{ marginRight: 6 }} /> Add
          </button>
        </div>
  
        {/* Table */}
        <table style={{ width: "100%", marginTop: 20, border: "1px solid #42987e" }}>
          {/* PG TABLE HEADER */}
  <thead style={{ background: "var(--pg-primary)", color: "#fff" }}>
  
            <tr>
              <th style={{ padding: 6 }}>#</th>
              <th style={{ padding: 6 }}>Title</th>
              <th style={{ padding: 6 }}>Description</th>
              <th style={{ padding: 6 }}>Image</th>
              <th style={{ padding: 6 }}>Actions</th>
            </tr>
          </thead>
  
          <tbody>
            {currentItems.map((slider, i) => (
              <tr key={slider.id}>
                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                  {i + 1}
                </td>
                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                  {slider.title}
                </td>
                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                  {slider.description}
                </td>
  
                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                  <img
                    src={slider.image}
                    style={{ width: 120, borderRadius: 6 }}
                    alt=""
                  />
                </td>
  
                <td style={{ border: "1px solid #ddd", textAlign: "center" }}>
                  <button
                    onClick={() => handleEdit(slider)}
                    style={{ background: "#fff)", color: "var(--pg-primary ", marginRight: 10 , cursor:"pointer", border:"none", outline:"none"}}
                  >
                    <FaEdit />
                  </button>
  
                  <button
                    onClick={() => handleDelete(slider.id)}
                    style={{ background: "#fff", color: "var(--pg-secondary)" , cursor:"pointer", border:"none", outline:"none"}}
                  >
                    <FaTrash />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
  
        {/* Pagination */}
        {totalPages > 1 && (
          <div
            style={{
              marginTop: 20,
              display: "flex",
              justifyContent: "center",
              gap: 6,
            }}
          >
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              style={{
                padding: "6px 12px",
                borderRadius: 6,
                background: currentPage === 1 ? "#eee" : "var(--pg-secondary)",
                color: currentPage === 1 ? "#555" : "#fff",
              }}
            >
              Prev
            </button>
  
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                style={{
                  padding: "6px 10px",
                  borderRadius: 6,
                  background: currentPage === page ? "var(--pg-secondary)" : "#fff",
                  color: currentPage === page ? "#fff" : "#333",
                }}
              >
                {page}
              </button>
            ))}
  
            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
              style={{
                padding: "6px 12px",
                borderRadius: 6,
                background: currentPage === totalPages ? "#eee" : "var(--pg-secondary)",
                color: currentPage === totalPages ? "#555" : "#fff",
              }}
            >
              Next
            </button>
          </div>
        )}
  
        {/* Modal */}
        {showModal && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.4)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 12,
                width: "90%",
                maxWidth: 420,
                padding: 25,
              }}
            >
              {/* Title Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
              
                  paddingBottom: 10,
                }}
              >
                <h3 style={{ color: "var(--primary)" }}>
                  {editingID ? "Edit Slide" : "Add Slide"}
                </h3>
                <FaTimes
                  onClick={() => setShowModal(false)}
                  style={{ cursor: "pointer" }}
                />
              </div>
  
              <form onSubmit={handleSubmit}>
  
                {/* Title */}
                <label style={labelStyle}>Title</label>
                <input
                  type="text"
                  value={form.title}
                  onChange={(e) => setForm({ ...form, title: e.target.value })}
                  style={{
                    width: "95%",
      border: "1px solid #ccc",
      borderRadius: 6,
      padding: "8px",
      fontSize: 14,
      cursor: "pointer",marginBottom: 15
                  }}
                  required
                />
  
                {/* Description */}
                <label style={labelStyle}>Description</label>
                <input
                  type="text"
                  value={form.description}
                  onChange={(e) => setForm({ ...form, description: e.target.value })}
                  style={{
                    width: "95%",
      border: "1px solid #ccc",
      borderRadius: 6,
      padding: "8px",
      fontSize: 14,
      cursor: "pointer",marginBottom: 15
                  }}
                  required
                />
  
                {/* Image */}
                <label style={labelStyle}>Image</label>
                <input
                  type="file"
                  onChange={handleImage}
                  style={{  width: "95%",
      border: "1px solid #ccc",
      borderRadius: 6,
      padding: "8px",
      fontSize: 14,
      cursor: "pointer",marginBottom: 15 }}
                />
  
                {form.image && (
                  <img
                    src={
                      typeof form.image === "string"
                        ? form.image
                        : URL.createObjectURL(form.image)
                    }
                    style={{ width: 100, borderRadius: 8, marginBottom: 10 }}
                  />
                )}
  
                <button
                  type="submit"
                       style={{
              background: "var(--pg-secondary)",
              color: "#fff",
              padding: "10px 15px",
              borderRadius: 6,
              marginTop: 15,
              width: "100%",
              fontWeight: 600,
              fontSize: 15,
              cursor: "pointer",
              border: "none",
              transition: "0.3s",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.background = "var(--pg-secondary)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.background = "var(--pg-secondary)")
            }
                >
                  {editingID ? "Update" : "Add"}
                </button>
  
              </form>
            </div>
          </div>
        )}
      </div>
    );

}


/* ---------- Styles ---------- */

const baseStyles = {
  container: {
    display: "flex",
    height: "100vh",
    fontFamily: "Segoe UI, sans-serif",
   /* PG ADMIN BACKGROUND */
background: "var(--pg-bg)",

  },
  sidebar: {
   background: "linear-gradient(180deg, var(--pg-primary), var(--pg-accent))",
    color: "#fff",
    transition: "width 0.3s ease",
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    padding: "15px 10px",
    boxShadow: "4px 0 20px rgba(0,0,0,0.15)",
    overflow: "hidden",
  },
  logoArea: {
    textAlign: "center",
    marginBottom: "1rem",
  },
  logoBlock: { lineHeight: 1.2,     marginTop: "8px", marginBottom: "8px",  },

  logoAccent: {
    color: "var(--pg-secondary)",
    fontWeight: "700",
    fontSize: "0.85rem",
    marginLeft: "4px",
       background: "rgba(255, 255, 255, 0.5)",
borderRadius: "8px",
 textTransform:"uppercase",
 padding:'5px',
  filter: "drop-shadow(0 2px 8px #fff)",

  },
  logoTagline: {
    fontSize: "0.7rem",
    color: "#c9d1d9",
    marginTop: "3px",
  },
  navItem: {
    display: "flex",
    alignItems: "center",
    padding: "12px 14px",
    marginBottom: "8px",
    borderRadius: "6px",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  navIcon: { fontSize: "18px", marginRight: "10px" },
  navLabel: { fontSize: "15px", fontWeight: "500" },
  mainArea: (sidebarOpen) => ({
    marginLeft: sidebarOpen ? "220px" : "70px",
    transition: "margin-left 0.3s ease",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  }),
  contentWrapper: {
    flex: 1,
    padding: "20px",
    overflowY: "auto",
  },
 logoContainer: {
    display: "inline-flex", // Ensures it aligns well with other text elements
    justifyContent: "center", // Centers the text horizontally
    alignItems: "center", // Centers the text vertically
   background: "rgba(255, 255, 255, 0.5)", borderRadius: "50%", // Ensures the shape is a circle filter: "drop-shadow(0 2px 8px #fff)", // Makes the whole container circular
   width: "42px",  height: "42px", // Set a fixed height (should match width for a circle) padding: "0",, // Padding to create space around the letters
    filter: "drop-shadow(0 2px 8px #fff)", // Same drop shadow for the whole logo
  },

  logoMain: { fontWeight: "800", color: "#fff", fontSize: "1.1rem", letterSpacing: "0.5px",    marginTop: "14px",     textTransform: "uppercase",  },

  logoMain1: {
    color: "var(--pg-primary)", // Color for "P" (if you want to change, do it here)
    fontWeight: "800",
    fontSize: "1.3rem",
    letterSpacing: "0.5px",
    marginRight: "1px", // Margin to separate "P" from "G"
  },

  logoG: {
    color: "var(--pg-secondary)", // Color for "G"
    fontWeight: "700",
    fontSize: "1.3rem",
    
  },
};

const headerStyles = {
  header: {
    height: "60px",
 /* PG HEADER THEME */
background: "linear-gradient(90deg, var(--pg-primary), var(--pg-secondary))",

    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 20px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.15)",
  },
  leftGroup: { display: "flex", alignItems: "center" },
  toggleBtn: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    fontSize: "20px",
  },
  profileArea: { position: "relative" },
  profileMenu: {
    position: "absolute",
    right: 0,
    top: "calc(100% + 10px)",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
    zIndex: 100,
  },
  profileMenuItem: {
    padding: "10px 10px",
    cursor: "pointer",
    color: "var(--pg-primary)",
    fontWeight: 500,
    borderBottom: "1px solid #eee",
   width:'160px'
  },
};

const contentStyles = {
 wrapper: {
/* PG GLASS CARD */
background: "rgba(255,255,255,0.92)",
backdropFilter: "blur(14px)",
border: "1px solid rgba(139,48,109,0.12)",

    borderRadius: "18px",
    padding: "35px",
    boxShadow:
      "0 14px 30px rgba(0,0,0,0.12), 0 4px 12px rgba(0,0,0,0.06)",
    border: "1px solid rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(8px)",
    transition: "0.3s ease-in-out",
  },

  title: {
    margin: 0,
    marginBottom: "14px",
    fontSize: "1.9rem",
    fontWeight: "700",
    letterSpacing: "0.6px",
    background: "var(--pg-primary)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subtitle: {
    margin: 0,
    marginTop: "5px",
    fontSize: "1rem",
    color: "#555",
    fontWeight: "500",
    opacity: 0.85,
  },
  formRow: { display: "flex", gap: "10px", marginBottom: "20px" },
  input: {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    flex: "0.3",
  },
  fileInput: {
    flex: "0.5",
    padding: "10px",
    border: "1px solid #ccc",
    borderRadius: "6px",
  },
  addBtn: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    padding: "10px 20px",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "background 0.3s, transform 0.2s",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    borderRadius: "8px",
    overflow: "hidden",
  },
  thead: { background: "var(--primary)", color: "#fff" },
  th: {
    textAlign: "left",
    padding: "10px",
    fontWeight: "600",
  },
  td: { padding: "10px", borderBottom: "1px solid #eee" },
  btnEdit: {
    background: "var(--primary)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    marginRight: "6px",
    cursor: "pointer",
  },
  btnDelete: {
    background: "var(--accent)",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "6px 10px",
    cursor: "pointer",
  },
  noData: { color: "#888", textAlign: "center", padding: "20px" },
};


const labelStyle = {
  display: "block",
  textAlign: "left",
  fontWeight: 600,
  marginBottom: 5,
    marginLeft: 5,
  color: "#333"
};

const inputStyle = {
  width: "95%",
  border: "1px solid #ccc",
  borderRadius: 6,
  padding: "8px",
  fontSize: 14,
  cursor: "pointer",
  marginBottom: 15
};

const cardStyle = {
  flex: 1,
  background: "#fff",
  padding: 20,
  borderRadius: 12,
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
};

const primaryBtn = {
  background: "var(--pg-secondary)",
  color: "#fff",
  padding: "10px 15px",
  borderRadius: 6,
  marginTop: 15,
  width: "100%",
  fontWeight: 600,
  fontSize: 15,
  cursor: "pointer",
  border: "none",
};

const actionIcon = {
  cursor: "pointer",
  marginRight: 12,
  color: "var(--pg-primary)",
};

const paginationStyle = {
  marginTop: 20,
  display: "flex",
  justifyContent: "center",
  gap: 6,
};
